import Accordion from './accordion';
import Alert from './alert';
import Avatar from './avatar';
import Badge from './badge';
import Button from './button';
import Checkbox from './checkbox';
import CloseButton from './close-button';
import Code from './code';
import Divider from './divider';
import Editable from './editable';
import Form from './form';
import Heading from './heading';
import Input from './input';
import InputAddon from './input-addon';
import Kbd from './kbd';
import Link from './link';
import Menu from './menu';
import Modal from './modal';
import NumberInput from './number-input';
import PinInput from './pin-input';
import Popover from './popover';
import Progress from './progress';
import Radio from './radio';
import Skeleton from './skeleton';
import Slider from './slider';
import Spinner from './spinner';
import Stat from './stat';
import Switch from './switch';
import Tabs from './tabs';
import Tag from './tag';
import Textarea from './textarea';
import Tooltip from './tooltip';

export default {
  Accordion,
  Button,
  Heading,
  Alert,
  Badge,
  Avatar,
  Link,
  Code,
  Divider,
  Spinner,
  Menu,
  Tabs,
  Checkbox,
  Radio,
  Input,
  InputAddon,
  Tooltip,
  CloseButton,
  Slider,
  NumberInput,
  Switch,
  Tag,
  Modal,
  Kbd,
  Select: Input,
  Textarea,
  PinInput,
  Popover,
  Form,
  Editable,
  Progress,
  Stat,
  Skeleton,
};
